// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import IziPayConfig from '../components/paymentProviderConfigs/IziPayConfig';
import {actions} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
    error: state.paymentMethodConfig.error,
    isSaving: state.paymentMethodConfig.isSaving,
    paymentMethod: state.paymentMethodConfig.paymentMethod,
    currency: state.currency.currency,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...actions,
      },
      dispatch
    )
)(IziPayConfig);
